import _ from 'lodash';

// Function to generate a 15-character unique key with an optional index
export function generateUniqueKey(index = '') {
    const uniqueKey = _.uniqueId().padEnd(15, '0').slice(0, 15 - index.toString().length);
    return uniqueKey + index;
}
